import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import api from "api/api";
import { PRODUCTS } from "constants/ApiRoutes";

const ProductContext = createContext([]);

const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [editProduct, setEditProduct] = useState({});
  const [idDeleteProduct, setIdDeleteProduct] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState();
  const [msg, setMsg] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const user = JSON.parse(localStorage.getItem("user"));

  const listProducts = async (page = 1, rowsPerPage = 10) => {
    setLoading(true);
    await api
      .get(PRODUCTS + `?page=` + page + `&` + `per_page=` + rowsPerPage)
      .then((response) => {
        const { data, current_page, last_page } = response.data;
        setProducts(data);
        setCurrentPage(current_page);
        setTotalPages(last_page);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const storeProduct = async (data) => {
    const { id, tenant_id } = user;
    setLoading(true);
    await api
      .post(PRODUCTS, {
        user_id: id,
        tenant_id: tenant_id,
        category_id: data.category_id,
        name: data.name,
        descricao: data.descricao,
        ean: data.ean,
        priceRetail: data.priceRetail,
        priceWholesale: data.priceWholesale,
        qtd_stock: data.qtd_stock,
        validity: data.validity,
        weight: data.weight,
      })
      .then((response) => {
        const { title, message } = response.data;
        setTitle(title);
        setIsOpen(true);
        setMsg(message);
      })
      .finally(() => {
        setLoading(false);
        listProducts();
      });
  };

  const updateProduct = async (data) => {
    const { id, tenant_id } = user;
    setLoading(true);
    await api
      .put(`${PRODUCTS}/${data.id}`, {
        user_id: id,
        tenant_id: tenant_id,
        category_id: data.category_id,
        name: data.name,
        descricao: data.descricao,
        ean: data.ean,
        priceRetail: data.priceRetail,
        priceWholesale: data.priceWholesale,
        qtd_stock: data.qtd_stock,
        validity: data.validity,
        weight: data.weight,
      })
      .then((response) => {
        const { message } = response.data;
        setTitle("Editado");
        setIsOpen(true);
        setMsg(message);
      })
      .finally(() => {
        setLoading(false);
        listProducts();
      });
  };

  const deleteProduct = async (id) => {
    await api
      .delete(`${PRODUCTS}/${id}`)
      .then((response) => {
        const { message } = response.data;
        setTitle("Deletado");
        setIsOpen(true);
        setMsg(message);
      })
      .finally(() => {
        listProducts();
      });
  };

  useEffect(() => {
    listProducts(page, rowsPerPage);
  }, [page, rowsPerPage]);

  useEffect(() => {
    listProducts();
  }, []);

  return (
    <ProductContext.Provider
      value={{
        products,
        editProduct,
        setEditProduct,
        idDeleteProduct,
        setIdDeleteProduct,
        storeProduct,
        updateProduct,
        deleteProduct,
        isOpen,
        setIsOpen,
        msg,
        setMsg,
        title,
        loading,
        setLoading,
        currentPage,
        totalPages,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

const useProduct = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error("useProduct must be used within a ProductProvider");
  }
  return context;
};

export { ProductProvider, useProduct };

ProductProvider.propTypes = {
  children: PropTypes.element,
};
